export default __webpack_public_path__ + "static/media/country.c28286c8.svg";